module.exports = __webpack_public_path__ + "img/weddingbox@2x.60a0d08.webp";